import { saveAs } from 'file-saver';
import { fromBlob } from 'image-resize-compress';
import { useTranslation } from "react-i18next";
import nextId from "react-id-generator";
import { cloudfront_base_url, cognito_app_client_id, cookie_url_endpoint } from '../config/config';
import { userData as sessionKeyUserData } from "../config/sessionKeys";
import AxiosServices from "../networks/AxiosService";
import GlobalConstants from "./GlobalConstants";


export function pageTitle(title) {
    document.title = title
}
const qs = require('query-string');

export function setSessionStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
    localStorage.setItem('amplify-signin-with-hostedUI', false);
    localStorage.setItem('CognitoIdentityServiceProvider.' + cognito_app_client_id + '.' + data.userId + '.accessToken', data.accessToken);
    localStorage.setItem('CognitoIdentityServiceProvider.' + cognito_app_client_id + '.' + data.userId + '.clockDrift', -132);
    localStorage.setItem('CognitoIdentityServiceProvider.' + cognito_app_client_id + '.' + data.userId + '.idToken', data.idToken);
    localStorage.setItem('CognitoIdentityServiceProvider.' + cognito_app_client_id + '.' + data.userId + '.refreshToken', data.refreshToken);
    localStorage.setItem('CognitoIdentityServiceProvider.' + cognito_app_client_id + '.' + data.userId + '.userData', JSON.stringify({
        "UserAttributes": [{
            "Name": "sub",
            "Value": data.userId
        }, {"Name": "email_verified", "Value": "true"}, {"Name": "profile", "Value": data.profile}, {
            "Name": "email",
            "Value": data.myEmail
        }], "Username": data.userId
    }))
    localStorage.setItem('CognitoIdentityServiceProvider.' + cognito_app_client_id + '.LastAuthUser', data.userId);
    return true
}


export function isLetter(str) {
    if (str !== undefined) return str.length === 1 && str.match(/\p{L}+/gu);
}

export const englishToBengleNumber=(num)=>{
    let numArray = Number(num).toString().split('');
    let newArray=[];
    numArray.forEach(n=>{
        if(n==='0') newArray.push('০')
        if(n==='1') newArray.push('১')
        if(n==='2') newArray.push('২')
        if(n==='3') newArray.push('৩')
        if(n==='4') newArray.push('৪')
        if(n==='5') newArray.push('৫')
        if(n==='6') newArray.push('৬')
        if(n==='7') newArray.push('৭')
        if(n==='8') newArray.push('৮')
        if(n==='9') newArray.push('৯')
        if(n==='.') newArray.push('.')
    })
    return newArray.join('')
}

/**
 * This method will check the object is not empty
 * @since 20-12-2022
 * @author Mahadi Hasan Joy
 * @param object
 * @returns {boolean}
 */
export const notEmptyObject = (object) =>{
    return object && object.constructor === Object && Object.keys(object).length > 0
}

export const returnNumberByLang=(num)=>{
    let lang = localStorage.getItem("i18nextLng");
    if (lang === 'en' || lang ==='en-US'){
        return num
    }
    else if(lang==='bn'){
        return englishToBengleNumber(num);
    }
}

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Courses Duration Hourly
export const onlyHours = (duration) => {
    const hours = duration ? `${duration / 3600}` : 0;

    return `${Number(hours).toFixed(2)} ${Number(hours) <= 1 ? ` Hour` : ' Hours'}`;
}

// Second Min Hour
export const secondsToHms = (d) => {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " h  " : " h  ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min  " : " min  ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " sec") : "";
    return hDisplay + mDisplay + sDisplay; 
}

export const getFormatDate = (d) => {
        const date = new Date(d)
        const formatDate = date.toDateString()
        return formatDate
    }

export const dateMonthYearCalculate = (timestamp) => {
    let d = new Date();
    let today = d.toLocaleString()
    let commmentDate = new Date(timestamp * 1000).toLocaleString();
    let currentDate = today.split(",")[0]
    let previousDate = commmentDate.split(",")[0]
    let diff = new Date(new Date(currentDate).getTime() - new Date(previousDate).getTime())
    let year = diff.getUTCFullYear() - 1970;
    let month = diff.getUTCMonth();
    let days = diff.getUTCDate() - 1;
    let result;
    if (year >= 2) {
        if (month >= 2) {
            if (days > 2) {
                result = `${year} years ${month} months ${days} days ago`
            } else {
                result = `${year} years ${month} months ${days} day ago`
            }
        } else if (month >= 1) {
            if (days > 2) {
                result = `${year} years ${month} month ${days} days`
            } else {
                result = `${year} years ${month} month ${days} day ago`
            }
        } else if (month >= 0) {
            if (days > 2) {
                result = `${year} years ${month} month ${days} days ago`
            } else {
                result = `${year} years ${month} month ${days} day ago`
            }
        }
    } else if (year === 1) {
        if (month >= 2) {
            if (days >= 2) {
                result = `${year} year ${month} months ${days} days ago`
            } else {
                result = `${year} year ${month} months ${days} day ago`
            }
        } else if (month >= 1 || month === 0) {
            if (days >= 2) {
                result = `${year} year ${month} month ${days} days ago`
            } else {
                result = `${year} year ${month} month ${days} day ago`
            }
        }
    } else if (year === 0) {
        if (month >= 2) {
            if (days >= 2) {
                result = `${month} months ${days} days ago`
            } else {
                result = `${month} months ${days} day ago`
            }
        } else if (month === 1) {
            if (days >= 2) {
                result = `${month} month ${days} days ago`
            } else {
                result = `${month} month ${days} day ago`
            }
        } else if (month === 0) {
            if (days >= 2) {
                result = `${days} days ago`
            } else {
                result = days === 0 ? `today` : null
            }
        }
    }

    return result;
}
export const getPreviewUrl = (url) => {
    const url1 = cloudfront_base_url;

    let finalUrl;

    if (url.includes(url1)) {
        finalUrl = `${url.split(url1)[1]}`
    } else {
        return false;
    }
    return finalUrl;
}
export const iframeLink = (url) => {
    if (url.includes("/embed/")) {
        return url;
    }
    const first = "https://www.youtube.com/embed/";
    if (url.includes("youtube.com")) {
        const parsed = qs.parse(`?${url.split("?")[1]}`);
        return `${first}${parsed.v}`;
    } else if (url.includes("youtu.be/")) {
        let specialUrl = url;
        if (specialUrl.includes("?")) {
            specialUrl = specialUrl.split("?")[0];
        }
        const last = specialUrl.split("youtu.be/")[1];
        return `${first}${last}`
    }

    return false;
}
export const isVideo = (value) => {
    let new_value = value.split('.');

    const extension = new_value[new_value.length - 1].toLocaleLowerCase();
    let videoTypes = ['mp4', 'mov', 'wmv', 'flv', 'avi', 'webm', 'mkv', 'm3u8'];
    if (videoTypes.indexOf(extension) !== -1) {
        return true;
    }
    return false;
}

export const getUrlHls = (keyUrl) => {
    const baseUrl = cloudfront_base_url;
    let url = keyUrl;
    const specialChars = {
        ";": "%3B",
        ",": "%2C",
        ":": "%3A",
        "&": "%26",
        "=": "%3D",
        "+": "%2B",
        "$": "%24",
        "#": "%23",
        "?": "%3F"
    }

    let urlList = url.split(".");
    urlList.pop();

    let urlList1 = urlList.join(".");
    urlList = urlList1.split("/");

    const fileName = urlList.pop();

    url = urlList.join("/");

    const burl = `${url}/hls/${fileName}_`;
    const ext = `_qvbr.m3u8`;

    const finalUrl = `${burl}${GlobalConstants.defaultResVideo}${ext}`;

    let specialEncoded = encodeURI(finalUrl);

    Object.entries(specialChars).map(([key, value]) => {
        specialEncoded = specialEncoded.replaceAll(key, value);
    })

    return `${baseUrl}${specialEncoded}`;
}
export const getPdfEx = (name) => {
    let a = name.split(".");
    a.pop();
    a.push("pdf");
    a = a.join(".");

    return a;
}
export function isPdf(llink) {
    const fileName = llink.split("/").pop();
    let a = fileName.split(".");
    let c = a.pop();

    if (c === "temppdf") {
        return true
    }
    return false;
}

export function leadingZero(n) {
    return (n < 10) ? ("0" + n) : n;
}

export const resolveFileName = (url) => {
    let name = String(url).split("/").pop();
    if (String(url).split("/").length === 1) {
        name = url;
        return url;
    }
    let fName = name.split("_");
    fName.splice(0, 1);
    fName = fName.join("_");

    if (isPdf(url)) {
        fName = getPdfEx(fName);
    }
    return fName;
}
export function downloaderPdf(url) {
    let fileName = url.split("/").pop();
    fileName = resolveFileName(fileName);
    saveAs(url, fileName);
}

export function checkLogin(){
    const userData = JSON.parse(localStorage.getItem(sessionKeyUserData));
    return userData !== null;
}

export const getPermission = async (payload, reqUrl, setCookie, setUrl, url, loader = () => {
}) => {
    // debugger
    loader(true);
    await AxiosServices.post(reqUrl, payload)
        .then(res => {
            const cookie = res.data.data;
            console.log(cookie);
            const options = {
                domain: cookie_url_endpoint,
                path: "/",
                secure: true,
            }
            for (const [key, value] of Object.entries(cookie)) {
                console.log(`${key}`, value, options);
                setCookie(`${key}`, value, options);
            }

            setTimeout(() => {
                setUrl(url);
            });

            loader(false);
        })
        .catch(err => {
            loader(false);
            setTimeout(() => {
                setUrl(url);
            });
            console.log(err);
        })
}

const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
function generateString(length) {
    let result = '';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result +=characters.charAt(Math.floor(Math.random()*charactersLength));
    }

    return result;
}
export const removeGarbageCharOnFileName = (fileName) => {
    const arr = fileName.split(".");
    const ext = arr.pop();

    let name = arr.join(".");
    const filterData = name.replace(/[^a-zA-Z0-9-_]/g, '');

    const finalStr = `${filterData}${generateString(8)}.${ext}`;
    return finalStr;
}
export const removeGarbageString = (fileName) => {
    return fileName.replace(/[^a-zA-Z0-9-_]/g, '');
}





const fileFormatValidator = (name, formatArr) => {
    let flag = false;
    formatArr.map(format => {
        if (name.includes(format)) {
            flag = true;
        }
    })

    return flag;
}

export const fileSizeValidator = (size, type, name, formatArr = []) => {
    const fileSizeMB = Math.round((size / 1024 / 1024));

    const baseFileSizeFormat = {
        "video": 500,
        "attachment": 50,
        "preview": 500,
        "image": 5
    }

    const filetype = {
        "video": [".mp4", ".m4v"],
        "attachment": [".zip", ".rar", ".tar"],
        "preview": [".mp4", ".m4v"],
        "image": ["image"]
    }

    if (name) {
        const formArr = formatArr.length ? formatArr : filetype[type];
        if (!fileFormatValidator(name, formArr)) {
            return "format_mismatch";
        }
    }

    if (!baseFileSizeFormat[type]) {
        return false;
    }

    if (fileSizeMB > baseFileSizeFormat[type]) {
        return false;
    }

    return true;
}

export const validateImageSize2 = async (file, cb) => {

    let img = new Image()
    img.src = window.URL.createObjectURL(file);
    img.onload = () => {
        cb(img)
    }
}

export const compressResizeImage = async (imageFile, config) => {
    const name = imageFile.name;
    let resizedFile;

    const imageResizer = async (imageObj) => {
        const quality = 80;
        const width = config.width;
        const height = config.height;
        const format = 'webp';

        let blobResized;


        await fromBlob(imageObj, quality, width, height, format)
            .then((blob) => {
                blobResized = blob;
            });

        return blobResized;
    }

    await imageResizer(imageFile)
        .then(file => {
            resizedFile = file;
        })

    resizedFile.name = name;

    return resizedFile
}

export const genericImageValidatorResizer = (file, config, setError, errObj, setImage, imageObj, e, onResizeImage, isNullErrorObj) => {

    const resolveAndSetErrors = (error) => {
        if (errObj) {
            setError(prev => ({
                ...prev,
                [errObj]: error
            }))
        } else {
            setError(error)
        }
    }

    const resolveAndSetImage = (editedFile) => {
        if (imageObj) {
            setImage(prev => ({
                ...prev,
                [imageObj]: editedFile
            }))
        } else {
            setImage(editedFile);
        }
    }

    const validation = fileSizeValidator(file.size, "image", file.type);
    if (validation === true) {
        validateImageSize2(file, (img) => {
            if (img.height >= config.height && img.width >= config.width) {
                resolveAndSetErrors("");
                validateImageSize2(file, async (img) => {
                    if (img.height > config.height || img.width > config.width) {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.addEventListener("load", () => {
                            onResizeImage(reader.result, file.name);
                        });

                        return;
                    } else {
                        resolveAndSetImage(file);
                    }
                })
            } else {
                e.target.value = "";
                if (!isNullErrorObj) {
                    setImage({});
                } else {
                    setImage(null);
                }
                resolveAndSetErrors(`Image width and height can't be less than ${config.width}X${config.height}`);
            }
        })
    } else if (validation === false) {
        if (!isNullErrorObj) {
            setImage({});
        } else {
            setImage(null);
        }
        resolveAndSetErrors("Please select an image less than 5MB");
    } else if (validation === "format_mismatch") {
        e.target.value = "";
        resolveAndSetErrors(`Please select an image`)
    }
}

export function assignmentDateGenerator(timestamp) {

    // console.log(timestamp)

    let date = new Date(Number(timestamp) * 1000);
    let month = date.toLocaleString('default', {month: 'short'});
    let day = date.getDate();
    let year = date.getFullYear();
    let hours = date.getHours();
    let amPm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    hours = hours < 10 ? '0' + hours : hours;
    let min = date.getUTCMinutes();
    min = min < 10 ? '0' + min : min;
    let sec = date.getSeconds();
    sec = sec < 10 ? '0' + sec : sec;
    return `${month} ${day}, ${year}  ${hours}:${min}:${sec} ${amPm}`;
}

export function TranslateErrorFormMessage(formikData){
    const {i18n} = useTranslation()
    i18n.on("languageChanged", () => {
        Object.keys(formikData.errors).forEach(fieldName => {
            formikData.setFieldTouched(fieldName);
        });
    });
}

export const getNewChapterId = async () => {
    const IdGE = nextId();
    return IdGE + `id` + `${generateString(10)}` + `${generateString(8)}`;
}

export function truncate(source, size) {
    let d = source.split(".")
    return d[0].length > size ? d[0].slice(0, size - 1) + "…" + d[1] : source;
}

export const ControlNumberField = (event, point) => {
    const inputValue = event.target.value;
    const key = event.key;
    if (!point && event.keyCode === 190 ||
        !point && event.key === "." ||
        event.keyCode === 189 ||
        event.keyCode === 187 ||
        event.key === "-" ||
        event.key === "+" ||
        event.keyCode === 69 ||
        event.key.toLowerCase() === "e") {
        event.preventDefault();
    }
};

export const goToLiveSession=(meeting_url,userId,idToken,refreshToken,name,myEmail,password,isLiveSession=true,tab="_blank")=>{
    try{
        console.log('start',meeting_url,userId,idToken);
        const url = `${meeting_url}?userId=${userId}&token=${idToken}&refreshToken=${refreshToken}&name=${name}&myEmail=${myEmail}&password=${password}&isLiveSession=${isLiveSession}&appEnvMode=${process.env.REACT_APP_ENV_MODE}`;
        window.open(url, tab);
    }
    catch(err){
        console.log('Start session failed',err);
    }
}

export const getActionBtnText=(status)=>{
    //calling appropriate action based on session's meeting status
    switch(status){
        case 'not_started':
            return 'View Details'
        case 'running':
            return 'Join Live Session';
        case 'ended':
            return 'View Details';
        default:
            return 'n/a'
    }
}

// DisCount Price Calculate
export function CalculateDiscountPrice(discountPrice, price) {
    const MainPrice = discountPrice || 0;
    const SalePrice = price || 0;
    const discountPercentage = Math.round(((SalePrice - MainPrice) / SalePrice) * 100);
    return discountPercentage
}

// convert youtube url to embed
export const convertYouTubeUrlToEmbed = (url) => {
    const urlObj = new URL(url);
    let videoId = "";
    if (urlObj.hostname === "youtube") {
        videoId = urlObj.pathname.slice(1);
    }
    if (url.includes("youtube.com/shorts/")) {
        videoId = url.split("shorts/")[1]?.split("?")[0];
    } else if (urlObj.searchParams.has("v")) {
        videoId = String(urlObj.searchParams.get("v"));
    }
    // Return the embed URL
    return `https://www.youtube.com/embed/${videoId}`;
};
